import React, { Fragment } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import Hero from '../Hero';

const useStyles = makeStyles((theme) => ({
  ctaPosition: {
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: '20vh',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
  wrapper: {
    height: '70vh',
    background: `linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 73.44%), url(${process.env.PUBLIC_URL}/images/home.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '50vh',
      backgroundPosition: 'center',
    },
  },
  ctaText: {
    width: '50vw',
    marginLeft: 'auto',
    marginRight: 'auto',
    color: 'white',
    fontSize: '1.5rem',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: '90vw',
    },
    [theme.breakpoints.down('sm')]: {
      width: '90vw',
      fontSize: '1.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      width: '98%',
      fontSize: '1rem',
    },
  },
  pvtPosition: {
    position: 'absolute',
    right: 10,
    width: 130,
    [theme.breakpoints.down('sm')]: {
      position: 'inherit',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }
}));

const HOME_TEXT = `
  NexSpec is revolutionizing the media and entertainment supply chain with innovative, scalable solutions. 
  We empower content owners and distributors to streamline workflows, maximize efficiencies, 
  and bridge the gap between providers, vendors, and platforms. 
`;

export default function HeadSection() {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.wrapper}>
        <img src={`${process.env.PUBLIC_URL}/images/pvt-prime.png`} alt='prime-preferred-vendor' className={classes.pvtPosition} />
        <Hero positionClass={classes.ctaPosition} />
        <Typography variant="h6" className={classes.ctaText}>{HOME_TEXT}</Typography>
      </div>
    </Fragment>
  );
}
